var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceCenterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 62,
    viewBox: "0 0 561 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.374 55.9997V21.2759H548.996C555.753 21.2759 560.161 25.3198 560.161 32.1967C560.161 39.0737 555.753 43.166 548.996 43.166H540.059V55.9997H533.374ZM540.059 37.2092H548.245C551.636 37.2092 553.452 35.272 553.452 32.1967C553.452 29.1215 551.636 27.2327 548.245 27.2327H540.059V37.2092Z",
    fill: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.639 55.9997V27.2327H497.65V21.2759H528.409V27.2327H516.348V55.9997H509.639Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.154 55.9998V21.2759H470.838V35.6595H485.975V21.2759H492.684V55.9998H485.975V41.6163H470.838V55.9998H464.154Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.359 55.9997V21.2759H457.638V27.2327H438.044V35.2235H454.659V41.1804H438.044V50.0429H458.146V55.9997H431.359Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M426.177 61.0224H419.686V55.9998H392.706V21.2759H399.39V50.043H414.237V21.2759H420.922V50.043H426.129L426.177 61.0224Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M364.685 21.2759H372.919V55.9998H366.211V30.3807L351.437 55.9998H343.25V21.2759H349.935V46.8708L364.685 21.2759ZM348.845 11.8564H354.246C354.44 13.6241 355.82 14.5927 357.879 14.5927C359.938 14.5927 361.391 13.6241 361.585 11.8564H366.986C366.889 16.3846 363.692 18.8061 357.879 18.8061C352.042 18.8061 348.942 16.4088 348.845 11.8564Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.287 38.6379C303.19 27.6928 310.262 20.6706 320.144 20.7917C330.026 20.6706 337.146 27.6928 337.025 38.6379C337.146 49.5829 330.026 56.6051 320.144 56.4841C310.262 56.6051 303.19 49.5829 303.287 38.6379ZM319.902 50.5515H320.41C326.586 50.5515 330.316 46.0476 330.316 38.6379C330.316 31.204 326.586 26.7485 320.41 26.7485H319.902C313.726 26.7485 309.996 31.204 309.996 38.6379C309.996 46.0476 313.726 50.5515 319.902 50.5515Z",
    fill: "#18191B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.141 55.9998V21.2759H287.52C294.011 21.2033 298.25 25.3198 298.177 30.2596C298.177 32.3178 297.644 34.0613 296.554 35.49C295.489 36.9186 294.084 37.8872 292.316 38.3957C296.046 39.1706 298.928 42.1974 298.928 46.774C299 51.9317 294.326 56.0966 288.005 55.9998H272.141ZM278.825 35.5142H286.527C289.748 35.5142 291.492 34.0613 291.492 31.3493C291.492 28.6372 289.748 27.2328 286.527 27.2328H278.825V35.5142ZM278.825 50.043H287.012C290.306 50.043 292.219 48.5417 292.219 45.6359C292.219 42.7301 290.306 41.2773 287.012 41.2773H278.825V50.043Z",
    fill: "#18191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.179 38.6379C232.082 27.6929 239.155 20.6706 249.036 20.7917C258.918 20.6706 266.038 27.6929 265.917 38.6379C266.038 49.5829 258.918 56.6052 249.036 56.4841C239.155 56.6052 232.082 49.5829 232.179 38.6379ZM248.794 50.5515H249.303C255.479 50.5515 259.208 46.0476 259.208 38.6379C259.208 31.204 255.479 26.7485 249.303 26.7485H248.794C242.618 26.7485 238.888 31.204 238.888 38.6379C238.888 46.0476 242.618 50.5515 248.794 50.5515Z",
    fill: "#18191B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.448 55.9998V21.2759H204.132V35.6595H219.27V21.2759H225.978V55.9998H219.27V41.6163H204.132V55.9998H197.448Z",
    fill: "#18191B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.654 55.9997V21.2759H190.932V27.2327H171.338V35.2235H187.953V41.1804H171.338V50.0429H191.441V55.9997H164.654Z",
    fill: "#18191B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.548 60.3745L152.981 60.3745V55.9998H126V21.2759H132.685V50.043H147.531V21.2759H154.216V50.043L158.5 50.043L158.548 60.3745Z",
    fill: "#18191B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333C0 21.4924 1.49238 20 3.33333 20H36.6667C38.5076 20 40 21.4924 40 23.3333V56.6667C40 58.5076 38.5076 60 36.6667 60H3.33333C1.49238 60 0 58.5076 0 56.6667V23.3333Z",
    fill: "url(#paint0_linear_15043_23176)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49239 31.4924 0 33.3333 0H86.6667C88.5076 0 90 1.49238 90 3.33333V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V3.33333Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33333C30 1.49239 31.4924 0 33.3333 0H86.6667C88.5076 0 90 1.49238 90 3.33333V56.6667C90 58.5076 88.5076 60 86.6667 60H33.3333C31.4924 60 30 58.5076 30 56.6667V3.33333Z",
    fill: "url(#paint1_linear_15043_23176)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9993 18.3333L69.9993 35H59.9993L49.9993 45L39.9993 50V56.6667C39.9993 58.5076 38.507 60 36.666 60H86.666C88.507 60 89.9993 58.5076 89.9993 56.6667V15L79.9993 18.3333Z",
    fill: "url(#paint2_linear_15043_23176)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 60H36.6667C38.5076 60 40 58.5076 40 56.6667V23.3333C40 21.4924 38.5076 20 36.6667 20H30V56.6667C30 58.5076 31.4924 60 33.3333 60Z",
    fill: "url(#paint3_linear_15043_23176)",
    fillOpacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90 13.2823L89.9333 13.2656L78.8883 16.9475L69.056 33.3336H59.3099L49.012 43.6304L40 48.1366V51.6669H40.3939L50.988 46.3701L60.6901 36.6669H70.944L81.1116 19.7197L90 16.757V13.2823Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15043_23176",
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15043_23176",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15043_23176",
    x1: 60.8327,
    y1: 16.6667,
    x2: 60.8327,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15043_23176",
    x1: 40,
    y1: 20,
    x2: 40,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E859FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.700419,
    stopColor: "#45CDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746439,
    stopColor: "#80F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792459,
    stopColor: "#30DDDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCenterLogo);
export default __webpack_public_path__ + "static/media/PriceCenterLogo.ad4faaad4b6810515b50a1952233245a.svg";
export { ForwardRef as ReactComponent };